<template>
  <div v-if="popups.length > 0 && !closed">
    <div class="modal-popup bg-black--0.7">
      <div class="table w--100% h--100%">
        <div class="table-cell text--middle text--center">
          <!-- 모바일 경우 하단 div에 w--80% m--auto 클래스 추가 -->
          <div
            class="inline-block position--relative"
            :class="$mq === 'mobile' ? 'w--80% m--auto' : ''"
          >
            <button
              class="black radius--round p--8px btn--modal-close position--absolute -top--12px -right--12px"
              type="button"
              @click="closePopup(popups[0])"
            >
              <i class="material-icons text--white font--18px">
                close
              </i>
            </button>
            <!-- 모바일일 경우 하단 img 태그에 w--100% 클래스 추가 -->
            <img
              :src="`/api/boards/popup/files/${popups[0].uuid}/${popups[0].files[0].fileName}`"
              :class="$mq === 'mobile' ? 'w--100%' : ''"
            >
            <div class="text--left pt--12px">
              <form-checkbox
                class="theme-white"
                label="오늘 하루 보지 않기"
                v-model="checked"
              ></form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <p
      class="text--white1"
      v-for="popup in this.popups"
      :key="popup.seq"
      @click="closePopup(popup)"
    >
      {{popup.title}}
    </p> -->
  </div>
</template>

<script>

function localStorageDenyedPopups (timeout) {
  let denyedPopups = JSON.parse(localStorage.denyedPopups || '[]')
  denyedPopups = denyedPopups.filter(popup => popup.createdAt > (Date.now() - timeout))
  localStorage.denyedPopups = JSON.stringify(denyedPopups)

  return denyedPopups
}

export default {
  props: {
    timeout: { type: Number, default: 24 * 3600 * 1000 }
  },
  data () {
    return {
      popups: [],
      checked: false,
      closed: false
    }
  },
  async created () {
    try {
      const res = await this.$http.get('/api/boards/popup', { params: { useFlag: 'Y', order: 'seq', orderType: 'asc' } })
      this.popups = []
      const denyedPopups = localStorageDenyedPopups(this.timeout)
      this.popups = res.data.rows.filter(row => denyedPopups.findIndex(denyedPopup => denyedPopup.seq === row.seq) < 0)
    } catch (ex) {
      console.error(ex, ex.response)
    }
  },
  methods: {
    closePopup ({ seq, title }) {
      if (this.checked) {
        const denyedPopups = localStorageDenyedPopups(this.timeout)
        if (!denyedPopups.find(popup => popup.seq === seq)) {
          denyedPopups.push({ seq, createdAt: Date.now() })
        }
        localStorage.denyedPopups = JSON.stringify(denyedPopups)

        this.popups = this.popups.filter(popup => popup.seq !== seq)
      }
      this.closed = true
    }
  },
  components: {
    FormCheckbox: () => import('@/component/ui2/form/FormCheckbox')
  }
}
</script>
